import { orientation_based_attr } from './ori_att'
import { ori_bas_attr_fil } from './orientation_based_attribute_filter'

import strengthTitle from '../../../images/strengthTitle.png';
import weaknessTitle from '../../../images/weaknessTitle.png';
import opportunityTitle from '../../../images/opportunityTitle.png';
import threatTitle from '../../../images/threatTitle.png';

import executionTitle from '../../../images/executionTitle.png';
import involvementDetailTitle from '../../../images/involvementDetailTitle.png';
import disciplineDetailTitle from '../../../images/disciplineDetailTitle.png';

import guideTitle from '../../../images/guideTitle.png';
import learnTitle from '../../../images/learnTitle.png';
import collaborateTitle from '../../../images/collaborateTitle.png';


import reviewQuestionsTitle from '../../../images/reviewQuestionsTitle.png';
import reviewQuestionsTemp1 from '../../../images/reviewQuestionsTemp1.png';


import concernTitle from '../../../images/concernTitle.png';
import advantageTitle from '../../../images/advantageTitle.png';
import positiveImpactTitle from '../../../images/positiveImpactTitle.png';
import negativeImpactTitle from '../../../images/negativeImpactTitle.png';


import improvementAreasTitle from '../../../images/improvementAreasTitle.png';

import orientationTitle from '../../../images/orientationTitle.png';

import achievement from '../../../images/achievement.png';
import sociability from '../../../images/sociability.png';
import leadership from '../../../images/leadership.png';
import learning from '../../../images/learning.png';
import integrity from '../../../images/integrity.png';

// import * as imageUrls from '../../../images/index';

import mostCompetentTitle from '../../../images/mostCompetentTitle.png';

const imageUrls = {
    achievement,
    sociability,
    leadership,
    learning,
    integrity,
};





function linearBackgroundChange(attr_name) {
    if(attr_name === 'STRENGTH') {
        return 'linear-gradient(to right, #d3ef77, #afef9a)'
    }else if(attr_name === 'WEAKNESS') {
        return 'linear-gradient(to right, #f3cba1, #e6a2ca)'
    }else if(attr_name === 'OPPORTUNITY') {
        return 'linear-gradient(to right, #d6d9f2, #a4cbcd)'
    }else if(attr_name === 'THREATS') {
        return 'linear-gradient(to right, #fff6a3, #f4cda0)'
    }
}

export function focus_area_all_linearBackgroundChange(attr_name) {
    if(attr_name === 'life_wheel_and_long_term_development_plan_text' || attr_name === 'EXECUTION') {
        return 'linear-gradient(to right, #d3ef77, #afef9a)'
    }else if(attr_name === 'descipline_text' || attr_name === 'DISCIPLINE') {
        return 'linear-gradient(to right, #d6d9f2, #a4cbcc)'
    }else if(attr_name === 'quality_engagement_text' || attr_name === 'ENGAGEMENT') {
        return 'linear-gradient(to right, #f1cdcf, #ddaef7)'
    }
}

export function focus_area_each_linearBackgroundChange(attr_name) {
    if(attr_name === 'Achievement') {
        return "linear-gradient(to right, #c3effa , #d3cef8)"
    }else if(attr_name === 'Relationship') {
        return "linear-gradient(to right, #f2cccb , #ebaa87)"
    }else if(attr_name === 'Leadership') {
        return "linear-gradient(to right, #f3d3d4 , #e6b1f7)"
    }else if(attr_name === 'Learning') {
        return "linear-gradient(to right, #fdf8c4 , #f7d872)"
    }else if(attr_name === 'Nurturing') {
        return "linear-gradient(to right, #d3f6ce , #adefa0)"
    }
    // "linear-gradient(to right, #d1ef79 , #b2ef97)"
}

export function lnd_active_class_linearBackgroundChange(attr_name) {
    if(attr_name === 'Achievement') {
        return "linear-gradient(to right, #2b61a5, #2b61a5)"
    }else if(attr_name === 'Relationship') {
        return "linear-gradient(to right, #d54b56, #d54b56)"
    }else if(attr_name === 'Leadership') {
        return "linear-gradient(to right, #9d4481, #9d4481)"
    }else if(attr_name === 'Learning') {
        return "linear-gradient(to right, #e48951, #e48951)"
    }else if(attr_name === 'Nurturing') {
        return "linear-gradient(to right, #5a924d, #5a924d)"
    }
}

export function collaboration_child_all_linearGradient(attr_name) {
    if(attr_name === 'current_team_strength') {
        return "linear-gradient(to right, #d3ef77 , #aeef9c)"
    }else if(attr_name === 'on_par_attributes') {
        return "linear-gradient(to right, #d5d9f2 , #a4cbcc)"
    }else if(attr_name === 'collabarated_team_strength') {
        return "linear-gradient(to right, #ecac6b , #eac6b0)"
    }
}

export function collaboration_team_background(attr_name) {
    if(attr_name === 'Achievement') {
        return {
            dark: "#244a7d",
            light: "#407cca"
        }
    }else if(attr_name === 'Relationship') {
        return {
            dark: "#a83940",
            light: "#dd506a"
        }
    }else if(attr_name === 'Leadership') {
        return {
            dark: "#773876",
            light: "#cc63c8"
        }
    }else if(attr_name === 'Learning') {
        return {
            dark: "#e89854",
            light: "#b5663d"
        }
    }else if(attr_name === 'Nurturing') {
        return {
            dark: "#436f42",
            light: "#83d37c"
        }
    }
    // "linear-gradient(to right, #d1ef79 , #b2ef97)"
}

export default function dataFormater(props,data,option,content_option) {
    var temp = data;
    if(option == "swot_all") {
        let final_arr = []
        var final_sorted_array = []
        var sort_key = ["strength","weakness","opportunity","threats"]
        for (var key in temp.swot_all) {
            var intermediate_arr = []
            if (temp.swot_all.hasOwnProperty(key)) {
                temp.swot_all[key].map((obj,index) => {
                    if(obj.attribute_name != undefined) {
                        intermediate_arr.push({
                            link: `/organisation/${props.match.params.id}/user/swot/${props.match.params.swotid}/swot-detail/${key}`,
                            child_content_background_color: linearBackgroundChange(key.toUpperCase()),
                            child_header: `${obj.attribute_name == undefined ? '' : obj.attribute_name}`,
                            child_content: obj.text,
                            child_footer: '(' + obj.orientation_name + ' Orientation)',
                        })
                    }else {
                        intermediate_arr.push({
                            noOrientationDetected: true,
                            link: ``,
                            child_content_background_color: '',
                            child_header: ``,
                            child_content: obj.text,
                            child_footer: ``,
                        })                       
                    }
                })
                final_arr.push({
                    link: `/organisation/${props.match.params.id}/user/swot/${props.match.params.swotid}/swot-detail/${key}`,
                    // header_background_image: `${key == "threats" ? 'threat' : key}Title`,
                    header_background_image: key == "threats" ? threatTitle : key === 'opportunity' ? opportunityTitle : key === 'weakness' ? weaknessTitle : strengthTitle,
                    header_text: `${key.toUpperCase()}`,
                    header_sub_text: `${key.toUpperCase() == "STRENGTH" ? "(Optimally skilled Areas)" : key.toUpperCase() == "WEAKNESS" ? "(Under-skilled Areas)" : key.toUpperCase() == "OPPORTUNITY" ? "(Potential Strengths)" : "(Over-skilled Areas)"}`,
                    child_content: intermediate_arr
                })
            }
        }
        sort_key.map((obj) => {
            final_arr.map((in_val) => {
                if(obj == in_val.header_text.toLowerCase()) {
                    final_sorted_array.push(in_val)
                }
            })
        })
        return final_sorted_array
    }
    if(option == "swot_each_orientation") {
        let final_arr = []; 
        var sort_key = ["strength","weakness","opportunity","threats"]
        temp.swot_each_orientation.map((obj,index) => {
            var final_sorted_array = []
            var before_final_array = []
            for (var key in obj.swot_analysis_of_each_orientation[0]) {
                var intermediate_arr = [];
                if (obj.swot_analysis_of_each_orientation[0].hasOwnProperty(key)) {
                    obj.swot_analysis_of_each_orientation[0][key].map((obj1,index1) => {
                        if(obj1.attribute_name != undefined) {
                            intermediate_arr.push({
                                link: ``,
                                child_content_background_color: linearBackgroundChange(key.toUpperCase()),
                                child_header: `${obj1.attribute_name}`,
                                child_content: obj1.text,
                                child_footer: '',
                            })
                        }else {
                            var att_count = 0
                            orientation_based_attr().orientaions.map(val => {
                                if(val.orientation__orientation_name == obj.orientation_name) {
                                    att_count = val.attributes.length
                                }
                            })
                            intermediate_arr.push({
                                // noOrientationDetected: true,
                                link: ``,
                                child_content_background_color: '',
                                child_header: `This team is not over-skilled in any of the ${att_count} attributes, so there are no apparent threats at this point.`,
                                child_content: ``,
                                child_footer: ``,
                            })                       
                        }
                    })
                    before_final_array.push({
                        link: ``,
                            header_background_image: key == "threats" ? threatTitle : key === 'opportunity' ? opportunityTitle : key === 'weakness' ? weaknessTitle : strengthTitle,
                            header_text: `${key.toUpperCase()}`,
                            header_sub_text: '',
                            child_content: intermediate_arr
                    })
                }
            }

            sort_key.map((obj) => {
                before_final_array.map((in_val) => {
                    if(obj == in_val.header_text.toLowerCase()) {
                        final_sorted_array.push(in_val)
                    }
                })
            })
            
            final_arr.push({
                "id": `${index + 1}`,
                "orientation_name": `${obj.orientation_name}`,
                "data": final_sorted_array
            })
        })
        return final_arr
    }
    if(option == "focus_area_all") {
        var final_arr = [];
        for (var key in temp.focus_area_all) {
            var intermediate_arr = [];
            if (temp.focus_area_all.hasOwnProperty(key)) {
                temp.focus_area_all[key].map((obj,index) => {
                    if(index < 2) {
                        intermediate_arr.push({
                            child_content_background_color: focus_area_all_linearBackgroundChange(key),
                            child_header: `${obj.attribute_name}`,
                            child_content: `${content_option.child_content == true ? obj.desciption : ''}`,
                            child_footer: '',
                            link: `/organisation/${props.match.params.id}/user/focus-area/all/${key == 'life_wheel_and_long_term_development_plan_text' ? 'life' : key == 'quality_engagement_text' ? 'involvement' : 'discipline'}`,
                        })
                    }
                })
                final_arr.push({
                    id: `${key == 'life_wheel_and_long_term_development_plan_text' ? 'life' : key == 'quality_engagement_text' ? 'involvement' : 'discipline'}`,
                    link: `/organisation/${props.match.params.id}/user/focus-area/all/${key == 'life_wheel_and_long_term_development_plan_text' ? 'life' : key == 'quality_engagement_text' ? 'involvement' : 'discipline'}`,
                    header_background_image: key === 'life_wheel_and_long_term_development_plan_text' ? executionTitle : key == 'quality_engagement_text' ? involvementDetailTitle : disciplineDetailTitle,
                    header_text: `${key == 'life_wheel_and_long_term_development_plan_text' ? 'EXECUTION' : key == 'quality_engagement_text' ? 'ENGAGEMENT' : 'DISCIPLINE'}`,
                    header_sub_text: `${key == 'life_wheel_and_long_term_development_plan_text' ? '(Operational Capabilities)' : key == 'quality_engagement_text' ? '(Level of Involvement)' : '(Structure and Timing)'}`,
                    child_content: intermediate_arr,
                    graph_data: temp.focus_area_all[key].map(areas => {
                        return {
                            ...areas,
                            average_score: areas.average_score
                        }
                    }),
                    position: key === 'life_wheel_and_long_term_development_plan_text' ? 1 : key === 'quality_engagement_text' ? 2 : 3
                })
            }
        }
        const sortArrayOfObjects = (arr, key) => {
            return arr.sort((a, b) => {
                return a[key] - b[key];
            });
        };
        
        const sortedArray = sortArrayOfObjects(final_arr, "position");

        return sortedArray
    }
    if(option == 'focus_area_of_each_orientation') {

        var final_arr = [];

        temp.focus_area_of_each_orientation.map((val,i) => {
            var intermediate_arr = [];
            
            val.focus_area.map((val1,index1) => {
                
                if(index1 > val.focus_area.length - 3) {
                    intermediate_arr.push({
                        name: `${val1.attribute_name}`,
                        discription: `${val1.desciption}`,
                        background_color: focus_area_each_linearBackgroundChange(val.orientation_name),
                    })
                }
            })
            final_arr.push({
                "id": `${i + 1}`,
                "orientation_name": `${val.orientation_name}`,
                "data": intermediate_arr.reverse(),
                "all_data": val.focus_area,
                "graph_data" : val.focus_area.map(areas => {
                    return {
                        ...areas,
                        average_score: areas.average_score
                    }
                })
            })
        })
        return final_arr
    }
    if(option == 'review_questions') {
        var final_arr = [];
        var intermediate_arr = []
        for (var key in temp.review_questions) {
            if (temp.review_questions.hasOwnProperty(key)) {
                if(key != 'context_questions') {
                    temp.review_questions[key].map((obj,index) => {
                        intermediate_arr.push({
                            child_content_background_color: 'linear-gradient(to right, #fcf279 , #d4ce5b)',
                            child_header: `${obj.atribute__attribute_name}`,
                            orientation_name: obj.orientation__orientation_name,
                            child_content: '',
                            child_footer: '',
                            review_question_text: `${obj.review_question_text}`,
                            link: `/organisation/${props.match.params.id}/user/review-questions/review-questions-details/${index}`,
                        })
                    })
                }
            }
        }
        final_arr.push({
            link: '',
            header_background_image: reviewQuestionsTitle,
            header_text: 'REVIEW QUESTIONS',
            header_sub_text: '',
            child_content: intermediate_arr
        })
        return final_arr
    }
    if(option == 'review_question_routable') {
        var final_arr = [];
        var review_questions_arr = dataFormater(props,temp,"review_questions")
        review_questions_arr[0].child_content.map((obj,key) => {
            var sub_flex_arr = [];
            let splitData = obj.review_question_text.split(`\n`)
                const returnData =
                    splitData.map(
                        (data, i) => {
                            if (data.trim().charAt(0) === '-' || data.trim().charAt(0) === '+') {
                                return data.trim().substr(1) 
                            }
                            else {
                                return data
                            }
                        }
                    )
            if(splitData.length > 1) {
                returnData.map((val,index) => {
                    sub_flex_arr.push({
                        text: `${val}`,
                        background_image: reviewQuestionsTemp1
                    })
                })
            }
            else {
                sub_flex_arr.push({
                    text: splitData[0],
                    background_image: reviewQuestionsTemp1
                })
            }
            var context_flex_arr = [];
            temp.review_questions.context_questions.map((v,i) => {
                if(v.orientation__orientation_name == obj.orientation_name) {
                    let splitData = v.review_question_text.split(`\n`)
                        const returnData =
                            splitData.map(
                                (data, i) => {
                                    if (data.trim().charAt(0) === '-') {
                                        return data.trim().substr(1) 
                                    }
                                    else {
                                        return data
                                    }
                                }
                            )
                    if(splitData.length > 1) {
                        returnData.map((val,index) => {
                            context_flex_arr.push({
                                text: `${val}`,
                                attr: v.atribute__attribute_name
                            })
                        })
                    }
                    else {
                        context_flex_arr.push({
                            text: splitData[0],
                            attr: v.atribute__attribute_name
                        })
                    }
                }
                
            }) 


            let childDataToAppend = [
                {
                    flex1: {
                        header: 'Recommended Contexts',
                        header_sub: '(to bring up the questions)',
                        points: context_flex_arr
                    },
                    flex2: {
                        sub_flex: sub_flex_arr
                    }
                }
            ]
            
           final_arr.push({
            navigation_arrow_link: `/organisation/${props.match.params.id}/user/review-questions/review-questions-details/`,
            header_text: `${obj.child_header}`,
            header_sub_text: 'Presenting their opinions at an appropriate context',
            id: key,
            chilc_data: childDataToAppend
           })
        })
        // console.log('fin',final_arr)
        return final_arr
    }
    if(option == 'collab_percentage_data') {
        var final_arr = [];

        orientation_based_attr().orientaions.map((obj1, i1) => {
            let intermediate_arr = []
            var count = 1
            obj1.attributes.map((obj2,i2) => {
                for (var key in temp) {
                    if (temp.hasOwnProperty(key)) {
                        if(key === 'collabaration_team_respondents_avg_score') {
                            temp[key].map(val => {
                                if(val.attribute_name === obj2.attribute__attribute_name) {
                                    intermediate_arr.push({
                                        attribute_name: val.attribute_name,
                                        average_score: val.average_score,
                                        team: 'collabaration_team_respondents_avg_score'
                                    })
                                }
                            })
                        }
                        if(key === 'current_team_respondents_avg_score') {
                            temp[key].map(val => {
                                if(val.attribute_name === obj2.attribute__attribute_name) {
                                    intermediate_arr.push({
                                        attribute_name: val.attribute_name,
                                        average_score: val.average_score,
                                        team: 'current_team_respondents_avg_score'
                                    })
                                }
                            })
                        }

                    }

                }
            })
            var output = [];

            intermediate_arr.forEach(function(item, pos) {
                let existing = output.filter(function(v, i) {
                    return v.attribute_name == item.attribute_name;
                });
                if (existing.length) {
                    let existingIndex = output.indexOf(existing[0]);
                    output[existingIndex].average_score = output[existingIndex].average_score.concat(
                        [
                            {
                                team: item.team,
                                score: item.average_score
                            }
                        ]
                    );
                } else {
                    if (typeof item.average_score == 'number')
                    item.average_score = [{
                        team: item.team,
                        score: item.average_score
                    }
                    ];
                    output.push(item);
                }
            });


            final_arr.push({
                orientation_name: obj1.orientation__orientation_name,
                link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/${obj1.orientation__orientation_name == "Relationship" ? "sociability" : obj1.orientation__orientation_name == "Nurturing" ? "integrity" : obj1.orientation__orientation_name.toLowerCase()}/${i1 + 1}`,
                floating_img: obj1.orientation__orientation_name == "Relationship" ? imageUrls["sociability"] : obj1.orientation__orientation_name == "Nurturing" ? imageUrls["integrity"] : imageUrls[obj1.orientation__orientation_name.toLowerCase()],
                header_background_image: orientationTitle,
                header_text: `${obj1.orientation__orientation_name}`,
                header_sub_text: '',
                child_content: output,
                backgroundColor: collaboration_team_background(obj1.orientation__orientation_name),
                teamData: {
                    selected_team: content_option.selected_team,
                    currentTeam: content_option.currentTeam,
                    currentTeamId: content_option.currentTeamId
                }
            })
        })



        return final_arr 

    }
    if(option == 'lnd_all') {
        var final_arr = [];
        orientation_based_attr().orientaions.sort((a,b) => {
            return a.orientation__orientation_order - b.orientation__orientation_order
        }).map ((obj1,i1) => {
            let intermediate_arr = []
            var count = 1
            obj1.attributes.map((obj2,i2) => {
                for (var key in temp.attribute_details) {
                    if (temp.attribute_details.hasOwnProperty(key)) {
                       if(key == obj2.attribute__attribute_name) {
                           intermediate_arr.push({
                                child_content_background_color: focus_area_each_linearBackgroundChange(obj1.orientation__orientation_name),
                                activeBackground: lnd_active_class_linearBackgroundChange(obj1.orientation__orientation_name),
                                child_header: `${key}`,
                                child_content: ``,
                                sub_child_content: `(${temp.attribute_details[key].length})`,
                                child_footer: '',
                                link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/${obj1.orientation__orientation_name == "Relationship" ? "sociability" : obj1.orientation__orientation_name == "Nurturing" ? "integrity" : obj1.orientation__orientation_name.toLowerCase()}/${count}`,
                                tool_tip_desc: `${key}`,
                                attribute_detail: temp.attribute_details[key]
                            })
                            count = count + 1
                       }
                    }
                }
            })
            final_arr.push({
                orientation_name: obj1.orientation__orientation_name,
                link: `/organisation/${props.match.params.id}/user/learning-and-development/orientations/${obj1.orientation__orientation_name == "Relationship" ? "sociability" : obj1.orientation__orientation_name == "Nurturing" ? "integrity" : obj1.orientation__orientation_name.toLowerCase()}/${i1 + 1}`,
                // floating_img: `https://uat-analytics.discoverself.com/images/orientations/${obj1.orientation__orientation_name == "Relationship" ? "sociability" : obj1.orientation__orientation_name == "Nurturing" ? "integrity" : obj1.orientation__orientation_name.toLowerCase()}.png`,
                floating_img: obj1.orientation__orientation_name == "Relationship" ? imageUrls["sociability"] : obj1.orientation__orientation_name == "Nurturing" ? imageUrls["integrity"] : imageUrls[obj1.orientation__orientation_name.toLowerCase()],
                header_background_image: orientationTitle,
                header_text: `${obj1.orientation__orientation_name}`,
                header_sub_text: '',
                child_content: intermediate_arr,
            })
        })
        return final_arr 
    }
    if(option == 'collaboration_all') {
        
        var final_arr = [];
        for (var key in temp) {
            if (temp.hasOwnProperty(key)) {
                if(key == 'current_team_strength') {
                    var intermediate_arr = [{
                        child_content_background_color: 'linear-gradient(to right, #fff , #fff)',
                        child_header: `Areas where Team ${content_option.currentTeam} can guide Team ${content_option.selected_team}`,
                        classNames: 'min-height-100',
                        child_content: '',
                        child_footer: '',
                        link: `/organisation/${props.match.params.id}/user/collaboration/detailed/1`,
                        no_arrow: true,
                        sub_header_enable: true
                    }]
                    var intermediate_arr_wrap = []
                    temp[key].map((ob,i) => {
                        const currentContext = temp['context_data'].filter(context => {
                            return context.orientation__orientation_name === ob.orientation_name
                        })
                        const currentContextObject = currentContext.length ? currentContext[0] : {}
                        intermediate_arr_wrap.push({
                            child_content_background_color: collaboration_child_all_linearGradient(key),
                            child_header: `${ob.attribute_name}`,
                            child_content: ob.attribute_description,
                            child_footer: `(${ob.orientation_name} Orientation)`,
                            child_recomended_points: {
                                header: 'Recommended contexts',
                                listData: [{
                                    value: currentContextObject.review_question_text
                                }]
                            },
                            show_button: 'Top Members',
                            popOverData: {
                                teamName: content_option.currentTeam,
                                members: ob.top_assessment.map(assessment=>{
                                    return assessment.participant_name ? assessment.participant_name : assessment.participant_email
                                })
                            },
                            link: `/organisation/${props.match.params.id}/user/collaboration/detailed/1/${content_option.currentTeamId}`, 
                        })

                        intermediate_arr.push(intermediate_arr_wrap[i])
                        

                    })
                    final_arr.push({
                        id: 1,
                        link: '',
                        header_background_image: guideTitle,
                        header_text: 'GUIDE',
                        header_sub_text: '',
                        child_content: intermediate_arr,
                        noChildContent: false,
                        intermediate_arr_wrap,
                        noChildMessage: intermediate_arr_wrap.length < 1 ? 'Guide data not found' : null
                    })

                }
                if(key == 'on_par_attributes') {
                    var intermediate_arr = [{
                        child_content_background_color: 'linear-gradient(to right, #fff , #fff)',
                        child_header: `Areas where Team ${content_option.currentTeam} and Team ${content_option.selected_team} are on par`,
                        classNames: 'min-height-100',
                        child_content: '',
                        child_footer: '',
                        link: `/organisation/${props.match.params.id}/user/collaboration/detailed/2`,
                        no_arrow: true,
                        sub_header_enable: true
                    }]
                    var intermediate_arr_wrap = []
                    temp[key].map((ob,i) => {
                        const currentContext = temp['context_data'].filter(context => {
                            return context.orientation__orientation_name === ob.orientation_name
                        })
                        const currentContextObject = currentContext.length ? currentContext[0] : {}
                        intermediate_arr_wrap.push({
                            child_content_background_color: collaboration_child_all_linearGradient(key),
                            child_header: `${ob.attribute_name}`,
                            child_content: ob.attribute_description,
                            child_recomended_points: {
                                header: 'Recommended contexts',
                                listData: [{
                                    value: currentContextObject.review_question_text
                                }]
                            },
                            child_footer: `(${ob.orientation_name} Orientation)`,
                            // show_button: 'Top Members',
                            link: `/organisation/${props.match.params.id}/user/collaboration/detailed/3/${content_option.currentTeamId}`, 
                        })

                        intermediate_arr.push(intermediate_arr_wrap[i])

                    })
                    final_arr.push({
                        id: 3,
                        link: '',
                        header_background_image: collaborateTitle,
                        header_text: 'COLLABORATE',
                        header_sub_text: '',
                        child_content: intermediate_arr,
                        noChildContent: false,
                        intermediate_arr_wrap,
                        noChildMessage: intermediate_arr_wrap.length < 1 ? 'Collaborate data not found' : null
                    })
                }
                if(key == 'collabarated_team_strength') {
                    var intermediate_arr = [{
                        child_content_background_color: 'linear-gradient(to right, #fff , #fff)',
                        child_header: `Areas where Team ${content_option.currentTeam} can learn from Team ${content_option.selected_team}`,
                        classNames: 'min-height-100',
                        child_content: '',
                        child_footer: '',
                        link: `/organisation/${props.match.params.id}/user/collaboration/detailed/2`,
                        no_arrow: true,
                        sub_header_enable: true
                    }]
                    var intermediate_arr_wrap = []

                    temp[key].map((ob,i) => {
                        const currentContext = temp['context_data'].filter(context => {
                            return context.orientation__orientation_name === ob.orientation_name
                        })
                        const currentContextObject = currentContext.length ? currentContext[0] : {}
                        intermediate_arr_wrap.push({
                            child_content_background_color: collaboration_child_all_linearGradient(key),
                            child_header: `${ob.attribute_name}`,
                            child_content: ob.attribute_description,
                            child_recomended_points: {
                                header: 'Recommended contexts',
                                listData: [{
                                    value: currentContextObject.review_question_text
                                }]
                            },
                            child_footer: `(${ob.orientation_name} Orientation)`,
                            show_button: 'Top Members',
                            popOverData: {
                                teamName: content_option.selected_team,
                                members: ob.top_assessment.map(assessment=>{
                                    return assessment.participant_name ? assessment.participant_name : assessment.participant_email
                                })
                            },
                            link: `/organisation/${props.match.params.id}/user/collaboration/detailed/2/${content_option.currentTeamId}`, 
                        })

                        intermediate_arr.push(intermediate_arr_wrap[i])

                    })
                    final_arr.push({
                        id: 2,
                        link: '',
                        header_background_image: learnTitle,
                        header_text: 'LEARN',
                        header_sub_text: '',
                        child_content: intermediate_arr,
                        noChildContent: false,
                        intermediate_arr_wrap,
                        noChildMessage: intermediate_arr_wrap.length < 1 ? 'Learn data not found' : null
                    })
                }
            }
        }
        const sortArrayOfObjects = (arr, key) => {
            return arr.sort((a, b) => {
                return a[key] - b[key];
            });
        };
        
        const sortedArray = sortArrayOfObjects(final_arr, "id");
        
        return sortedArray
    }
    if(option == 'team_fitment_single_team_team_member') {
       var final_arr_sumbmit = []
       temp.map((val,index) => {
        var final_arr = [];
        for (var key in val) {
            var intermediate_arr = []
             if (val.hasOwnProperty(key)) {
                 if(key == 'positive_impact_all_attributes') {
                    val[key].sort((a, b) => b.diff - a.diff).map((obj,i) => {
                        //  if(i < 3) {
                        // }
                        intermediate_arr.push({
                            child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                            child_header: `${obj.attribute_name}`,
                            child_content: '',
                            child_footer: '',
                            child_footer_desc: obj.attribute_description,
                            show_arrow_content: true,
                            link: ``,
                        })
                     })
                     final_arr.push({
                         link: '',
                         header_background_image: positiveImpactTitle,
                         header_background_color: '#24540f',
                         header_text: 'POSITIVE IMPACT',
                         header_sub_text: '(Individual is better than team)',
                         child_content: intermediate_arr,
                     })
                 }
                 if(key == 'negative_impact_all_attributes') {
                    val[key].sort((a, b) => b.diff - a.diff).map((obj,i) => {
                        //  if(i < 3) {
                        // }
                        intermediate_arr.push({
                            child_content_background_color: 'linear-gradient(to right, #f3cba1, #e6a2ca)',
                            child_header: `${obj.attribute_name}`,
                            child_content: '',
                            child_footer: '',
                            child_footer_desc: obj.attribute_description,
                            show_arrow_content: true,
                            link: ``,
                        })
                     })
                     final_arr.push({
                         link: '',
                         header_background_image: negativeImpactTitle,
                         header_background_color: '#c73129',
                         header_text: 'NEGATIVE IMPACT',
                         header_sub_text: '(Team is better than individual)',
                         child_content: intermediate_arr,
                     })
                 }
                 if(key == 'advantage_all_attributes') {
                    val[key].map((obj,i) => {
                        //  if(i < 3) {
                        // }
                        intermediate_arr.push({
                        child_content_background_color: 'linear-gradient(to right, #d6d9f2, #a4cbcd)',
                        child_header: `${obj.attribute_name}`,
                        child_content: '',
                        child_footer: '',
                        child_footer_desc: obj.attribute_description,
                        show_arrow_content: true,
                        link: ``,
                        })
                     })
                     final_arr.push({
                         link: '',
                         header_background_image: advantageTitle,
                         header_background_color: '#162ba2',
                         header_text: 'ADVANTAGE',
                         header_sub_text: '(Common Strength)',
                         child_content: intermediate_arr,
                     })
                 }
                 if(key == 'disadvantage_all_attributes') {
                    val[key].map((obj,i) => {
                        //  if(i < 3) {
                        // }
                        intermediate_arr.push({
                            child_content_background_color: 'linear-gradient(to right, #fff6a3, #f4cda0)',
                            child_header: `${obj.attribute_name}`,
                            child_content: '',
                            show_arrow_content: true,
                            child_footer_desc: obj.attribute_description,
                            child_footer: '',
                            link: ``,
                        })
                     })
                     final_arr.push({
                         link: '',
                         header_background_image: concernTitle,
                         header_background_color: '#7c3718',
                         header_text: 'DISADVANTAGE',
                         header_sub_text: '(Common Weakness)',
                         child_content: intermediate_arr,
                     })
                 }
             }
             
         }
         var final_filtered_arr  = []
         var order = ["POSITIVE IMPACT","NEGATIVE IMPACT","ADVANTAGE","DISADVANTAGE"]
         order.map((ob)=> {
          final_arr.map(obj => {
              if(ob == obj.header_text) {
                  final_filtered_arr.push(obj)
              }
          })   
         })
         final_arr_sumbmit.push({
            team_id: val.team_id,
            team_leader: val.team_leader,
            team_member: val.team_member,
            array: final_filtered_arr
         })
       })
       return final_arr_sumbmit
    }
    if(option == 'attr_pre') {
        var final_arr = []
        for (var key in temp) {
            if (temp.hasOwnProperty(key)) {
                final_arr.push({
                    employeeName: temp[key].paticipants,
                    retentionTips: temp[key].text,
                })
            }
        }
        return final_arr
    }
    if(option == 'competency_list') {
        var final_arr = [];
        for (const key in temp) {
            if (temp.hasOwnProperty(key)) {
                const element = temp[key];
                var intermediate_arr = [];
                element.map((ob) => {
                    intermediate_arr.push({
                        name: ob.competency_metric__competency_name ? ob.competency_metric__competency_name : ob.assessment_organisation_competency__competency_name,
                        id: ob.id,
                        isChecked: false
                    })
                })
                final_arr.push({
                    name: `${key}_data`,
                    disabled: false,
                    heading: key.charAt(0).toUpperCase() + key.slice(1),
                    count: 0,
                    data: intermediate_arr
                })
            }
        }
        // temp.map((obj,i) => {
        //     var intermediate_arr = [];
        //     obj.metrics.map((ob) => {
        //         intermediate_arr.push({
        //             name: ob.competency_metric__competency_name,
        //             id: ob.competency_metric__id,
        //             isChecked: false
        //         })
        //     })
        //     final_arr.push({
        //             name: `${obj.competency_name}_data`,
        //             disabled: false,
        //             heading: obj.competency_name,
        //             count: 0,
        //             data: intermediate_arr
        //     })
        // })
    return final_arr
    }
    if(option == 'competency_data_each') {
        var fin_arr = [];
        var contextObject = {};
        temp.context_data.map(context => {
            contextObject[context.orientation__orientation_name] = context.review_question_text
        })
        temp.individual.map((obj) => {
            var data = [];
            var data_child_content = [];
            var data1 = [];
            var data1_child_content = [];
            obj.development_plan_and_most_competent_of_indivisual.map(ob => {
                data_child_content.push({
                    child_content_background_color: 'linear-gradient(to right, #ecae70 , #edbe9d)',
                    child_header: ob.attribute_name,
                    review_question_text: contextObject[ob.orientation_name],
                    child_content: ob.description,
                    show_arrow_content: true,
                    child_footer: '(' + ori_bas_attr_fil(ob.attribute_name) + ' Orientation'+')',
                    attribute_name: ob.attribute_name,
                    link: ``,
                })
            })
            data.push({
                link: '',
                header_background_image: improvementAreasTitle,
                header_text: 'IMPROVEMENT AREAS',
                header_sub_text: '(Top 2 areas to enhance Competency)',
                child_content: data_child_content
            })
            obj.development_plan_and_most_competent_of_indivisual.map(ob => {
                ob.most_competent.map((val) => {
                    data1_child_content.push({
                        child_content_background_color: 'linear-gradient(to right, #d3d9f1 , #b1cfd6)',
                        child_header: val.name ? val.name : val.email,
                        attribute_score: val.attribute_score,
                        child_content: '',
                        child_footer: '',
                        attribute_name: ob.attribute_name,
                        link: ``,
                    })
                })
            })
            data1.push({
                link: '',
                header_background_image: mostCompetentTitle,
                header_text: 'MOST COMPETENT',
                header_sub_text: '(People who can guide the team in these ares)',
                child_content: data1_child_content
            })
            var competency_title = ''
            var competency_non_disabled_list = []
            content_option.map((value) => {
                if(value.disabled == false) {
                    competency_non_disabled_list = value.data
                    value.data.map((value2) => {
                        if(obj.competency_id == value2.id) {
                            competency_title = value2.name
                        }
                    })
                }
            })
            var attribute = []
            obj.attributes.map((object) => {
                var inter_attributes = 0
                object.attributes.map((object_inner) => {
                    inter_attributes = inter_attributes + object_inner.average_score
                })
                attribute.push({
                    name: object.name ? object.name : object.email,
                    average_score: (inter_attributes / object.attributes.length).toFixed(2)
                })
            })
            let currentLevelName = ''
            temp.competency_levels.map(level => {
                if(level.start_value <= obj.sum_of_attribute_weightage && level.end_value > obj.sum_of_attribute_weightage) {
                    currentLevelName = level.level_name
                }
            })
            fin_arr.push({
                attributes: attribute,
                competency_title: competency_title,
                competency_non_disabled_list: competency_non_disabled_list,
                competency_id: obj.competency_id,
                levels: temp.competency_levels,
                data: data,
                data1: data1,
                competency_avg: obj.sum_of_attribute_weightage,
                currentLevelName: currentLevelName,
            })
        })
        return fin_arr
    }
}


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/dataFormater.js